module.exports = __webpack_public_path__ + "img/Like.55208c01.svg";